module.exports = __webpack_public_path__ + "img/pl.110889da.png";